import {LIST_CUSTOMER_MAILING_LIST} from "../../constants/customerReviews";


export const listCustomerMailingList = () => ({
    type: LIST_CUSTOMER_MAILING_LIST
})